import { IconCaretMd } from 'assets/svg/sprite'
import './_flashingArrow.scss'

interface Props {
    side: string
    clickFn?: () => void
    color?: string
}

export const FlashingArrow = ({ clickFn, side, color }: Props) => {
    return (
        <div
            className={`arrows__wrapper ${side} `}
            onClick={() => clickFn && clickFn()}
        >
            <div className='arrow__flashing first'>
                <IconCaretMd color={color} />
            </div>
            <div className='arrow__flashing second'>
                <IconCaretMd color={color} />
            </div>
            <div className='arrow__flashing third'>
                <IconCaretMd color={color} />
            </div>
        </div>
    )
}
